import { Component, OnInit } from '@angular/core';
import { CategoryList } from '@data/admin/pickList-admin/pick-list-admin';
import { PickListAdminService } from '@data/admin/pickList-admin/pick-list-admin.service';
import { CommonConstants } from '@mpg-core/constants/common-constants';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { CommonDataService } from '@shared/services/common-data.service';

@Component({
  selector: 'app-picklist-admin',
  templateUrl: './picklist-admin.component.html',
  styleUrls: ['./picklist-admin.component.less']
})
export class PicklistAdminComponent implements OnInit {
  showLoadPanel: boolean = false;
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:true,
    ofPosition:'#publishHistoryGrid',
    shadingColor:'rgba(0,0,0,0.05)'
  };
  isAdminOrFinExec: boolean = false;
  pickListCategoriesList: any;
  pickListAdmin: any;
  VendorIdAdmin: any;

  allowPickListDelete: boolean = true;
  allowPickListUpdate: boolean = true;

  deleteStatusOptions: any[];

  refreshMode: string;

  vendorSelect: boolean = false;

  loadingData:boolean=true;

  openConfirmationPopup: boolean = false;


  categoryGroupList:CategoryList[]=[];
  selectedValue:any;

  allowStatusEdit:boolean = false;
  editRow: any;

  constructor(private _picklistAdmin: PickListAdminService, private commonDataService: CommonDataService) {
    this.refreshMode = 'reshape';
    this.fetchAllCategories();
    if (this.commonDataService.userInfo.value.userRole.roleId === CommonConstants.SUPER_ADMIN_ROLE_ID
      || this.commonDataService.userInfo.value.userRole.roleId === CommonConstants.POST_PRODUCTION_ADMIN){
        this.isAdminOrFinExec = true;
      };
      this.allowUpdate= this.allowUpdate.bind(this);
      this.allowDelete = this.allowDelete.bind(this);
      this.allowAdd = this.allowAdd.bind(this);
      this.deleteStatusOptions = this._picklistAdmin.getDeleteStatusOptions();
      this.vendorOrderValidation = this.vendorOrderValidation.bind(this);
      this.vendorNameValidation = this.vendorNameValidation.bind(this);
      this.detailsOrderValidation = this.detailsOrderValidation.bind(this);
      this.detailsNameValidation = this.detailsNameValidation.bind(this);

   }

  ngOnInit(): void {

  }

  allowDelete(e:any) {
    return (this.isAdminOrFinExec && !e.row.data.deleteFlag) as boolean;
  }

  allowAdd(e:any){
    return (this.isAdminOrFinExec) as boolean;
  }

  allowUpdate(e:any){
    return (this.isAdminOrFinExec) as boolean;
  }
  

  fetchAllCategories(){
    this.categoryGroupList = [{
      categoryId : 1,
      value: "Post Production Summary"
    }];
    this.selectedValue = this.categoryGroupList[0].categoryId;
    this.getCategoryByGroupName(this.categoryGroupList[0].value)
  }
  getCategoryByGroupName(event: any){
    this.loadingData=true;
    // getCategoriesList
    this._picklistAdmin.getCategorieByName(event).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          this.pickListCategoriesList = r.serviceResult??[];
          let firstdata = this.pickListCategoriesList[0].picklistCategoryId;
          this.getAllPicklistOrders(firstdata);
          this.loadingData=false;
        }
      });
    
  }

  detailsOrderValidation(params: any){
    let orderList = this.pickListAdmin.map((a:any) => a.displayOrder);
    let val = params.data.displayOrder;
    if(this.editRow != null && this.editRow != ""){
      if(this.editRow.displayOrder != params.data.displayOrder){
        if(orderList.includes(val)){
          return false
        }else{
          return true
        }
      }else {
        return true;
      }
    }else if(orderList.includes(val)){
      return false
    }else{
      return true
    }
  }

  detailsNameValidation(params: any) {
    let valueList = this.pickListAdmin.map((a:any) => a.value.toString().toLowerCase());
    let val = params.data.value.toString().toLowerCase();
    if(this.editRow != null && this.editRow != ""){
      if(this.editRow.value != params.data.value){
        if(valueList.includes(val)){
          return false
        }else{
          return true
        }
      }else {
        return true;
      }
    }else if(valueList.includes(val)){
      return false
    }else{
      return true
    }
  }

 vendorOrderValidation(params: any){
    let orderList = this.VendorIdAdmin.map((a:any) => a.displayOrder);
    let val = params.data.displayOrder;
    if(this.editRow != null && this.editRow != ""){
      if(this.editRow.displayOrder != params.data.displayOrder){
        if(orderList.includes(val)){
          return false
        }else{
          return true
        }
      }else {
        return true;
      }
    }else if(orderList.includes(val)){
      return false
    }else{
      return true
    }
  }

  vendorNameValidation(params: any){
    let valueList = this.VendorIdAdmin.map((a:any) => a.name.toString().toLowerCase());
    let val = params.data.name.toString().toLowerCase();
    if(this.editRow != null && this.editRow != ""){
      if(this.editRow.name != params.data.name){
        if(valueList.includes(val)){
          return false
        }else{
          return true
        }
      }else {
        return true;
      }
    }else if(valueList.includes(val)){
      return false
    }else{
      return true
    }
  }

 

 

  getAllPicklistOrders(event: any){
    this.showLoadPanel=true;
    // getCategoriesList
    this.pickListAdmin = [];
    this._picklistAdmin.getPicklist(event).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          this.pickListAdmin = r.serviceResult??[];
          this.showLoadPanel=false;
        }
      });
    
  }

  onSelect(e:any){
    let data = e.addedItems[0].picklistCategoryId;
    if(data){
      this.vendorSelect = false;
      this.getAllPicklistOrders(data);
    }else{
      this.vendorSelect = true;
      this.getVendorList();
    }
    
  }

  getVendorList(){
    this.showLoadPanel=true;
    this.pickListAdmin = [];
    this._picklistAdmin.getVendors().subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          this.VendorIdAdmin = r.serviceResult??[];
          this.showLoadPanel=false;
        }
      });
  }

  updateVendorCategory(e: any){
    if(!e || !e.changes.length){
			this.showLoadPanel=false;
			return;
		}
    this.showLoadPanel = true;
    let payload: any = [];
    let key: any = e.changes[0].key;
		let operation:string = e.changes[0].type;
      if(operation=='insert'){
        payload = {
          "name": e.changes[0].data.name,
          "displayOrder": e.changes[0].data.displayOrder,
          "deleteFlag":false
        }
  
      }else if(operation=="update"){
        payload = {
          
          "name": e.changes[0].data.name,
          "displayOrder": e.changes[0].data.displayOrder,
          "deleteFlag":false,
          "vendorId": e.changes[0].data.vendorId,
        }
      }else if(operation=="remove"){
        payload = {
          "name": e.changes[0].key.name,
          "displayOrder": e.changes[0].key.displayOrder,
          "deleteFlag":true,
          "vendorId": e.changes[0].key.vendorId,
        }
      }
      this.saveVendorDetails(payload);
  }

  updatePickListCategory(e: any, d: any){
    if(!e || !e.changes.length){
			this.showLoadPanel=false;
			return;
		}
    this.showLoadPanel = true;
    let payload: any = [];
    let key: any = e.changes[0].key;
		let operation:string = e.changes[0].type;
      if(operation=='insert'){
        payload = {
          "picklistCategoryId": d[0].picklistCategoryId,
          "value": e.changes[0].data.value,
          "displayOrder": e.changes[0].data.displayOrder,
          "deleteFlag":false
        }
  
      }else if(operation=="update"){
        payload = {
          "picklistDetailId": e.changes[0].data.picklistDetailId,
          "picklistCategoryId": d[0].picklistCategoryId,
          "value": e.changes[0].data.value,
          "displayOrder": e.changes[0].data.displayOrder,
          "deleteFlag":false
        }
      }else if(operation=="remove"){
        payload = {
          "picklistDetailId": e.changes[0].key.picklistDetailId,
          "picklistCategoryId": d[0].picklistCategoryId,
          "value": e.changes[0].key.value,
          "displayOrder": e.changes[0].key.displayOrder,
          "deleteFlag":true
        }
      }
      this.savePickListDetails(payload);
			
	}

  savePickListDetails(payload: any){
    this._picklistAdmin.savePickListDetail(payload).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          this.showLoadPanel=false;
          let data = r.serviceResult.picklistCategoryId;
          this.vendorSelect = false;
          this.getAllPicklistOrders(data);
          this.commonDataService.fetchAllCommonData();
        }
      });
  }

  saveVendorDetails(payload: any){
    this._picklistAdmin.saveVendor(payload).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          this.showLoadPanel=false;
          this.vendorSelect = true;
          this.getVendorList();
          this.commonDataService.fetchAllCommonData();
        }
      });
  }

  // changePickListCat(e: any){

  // }

  onAdd(e: any){
    this.allowStatusEdit = false;
    let max:any;
    if(this.pickListAdmin.length != 0){
      let disOrder = this.pickListAdmin.map((a:any) => a.displayOrder);
      max = Math.max( ...disOrder )
    }else if(this.VendorIdAdmin.length != 0){
      let disVendor = this.VendorIdAdmin.map((a:any) => a.displayOrder);
      max = Math.max( ...disVendor )
    }
    e.data.displayOrder = max + 1;
    this.editRow = "";
  }

  onEditingStart(e: any){
    this.editRow = e.data;
    if(e.data.deleteFlag){
      this.allowStatusEdit = true;
    }else{
      this.allowStatusEdit = false;
    }
  }

}
